module.exports = __webpack_public_path__ + "h5/img/single_choose_icon_ed.e8a322ed.png";